(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $f894f8ec569435b3$exports = {};
$f894f8ec569435b3$exports = ":host{display:block}:host,.overflow-page{width:100%;height:100%}.main,.overflow{height:100%;transition:transform .3s,opacity .3s,visibility .3s}.overflow-page{grid-template-columns:100% 100%;display:grid;position:relative;overflow:hidden}.overflow{opacity:0;visibility:hidden;inset:0 -100% 0 100%}.overflow-page.overflow--active .main{opacity:0;visibility:hidden;transform:translate(-100%)}.overflow-page.overflow--active .overflow{opacity:1;visibility:visible;transform:translate(-100%)}:host *{box-sizing:border-box}:host,#sentry-container,#sentry-container iframe{color-scheme:normal;background:0 0;border:0;width:100%;height:100%}#sentry-iframe{position:fixed;top:-10000px;left:-10000px}@-webkit-keyframes shimmer{0%{background-position:-100% 0}to{background-position:100% 0}}@keyframes shimmer{0%{background-position:-1200px 0}to{background-position:1200px 0}}.social-button-loader{background:linear-gradient(90deg,#f8f8f8 8%,#eee 18%,#f8f8f8 33%) 0 0/1200px 100%;animation-name:shimmer;animation-duration:2.2s;animation-timing-function:linear;animation-iteration-count:infinite;animation-fill-mode:forwards}#sentry-container.light-mode{--blue-100-rgb:224,242,255;--blue-100:rgba(var(--blue-100-rgb));--blue-200-rgb:202,232,255;--blue-200:rgba(var(--blue-200-rgb));--blue-300-rgb:181,222,255;--blue-300:rgba(var(--blue-300-rgb));--blue-400-rgb:150,206,253;--blue-400:rgba(var(--blue-400-rgb));--blue-500-rgb:120,187,250;--blue-500:rgba(var(--blue-500-rgb));--blue-600-rgb:89,167,246;--blue-600:rgba(var(--blue-600-rgb));--blue-700-rgb:56,146,243;--blue-700:rgba(var(--blue-700-rgb));--blue-800-rgb:20,122,243;--blue-800:rgba(var(--blue-800-rgb));--blue-900-rgb:2,101,220;--blue-900:rgba(var(--blue-900-rgb));--blue-1000-rgb:0,84,182;--blue-1000:rgba(var(--blue-1000-rgb));--blue-1100-rgb:0,68,145;--blue-1100:rgba(var(--blue-1100-rgb));--blue-1200-rgb:0,53,113;--blue-1200:rgba(var(--blue-1200-rgb));--blue-1300-rgb:0,39,84;--blue-1300:rgba(var(--blue-1300-rgb));--blue-1400-rgb:0,28,60;--blue-1400:rgba(var(--blue-1400-rgb));--red-100-rgb:255,235,231;--red-100:rgba(var(--red-100-rgb));--red-200-rgb:255,221,214;--red-200:rgba(var(--red-200-rgb));--red-300-rgb:255,205,195;--red-300:rgba(var(--red-300-rgb));--red-400-rgb:255,183,169;--red-400:rgba(var(--red-400-rgb));--red-500-rgb:255,155,136;--red-500:rgba(var(--red-500-rgb));--red-600-rgb:255,124,101;--red-600:rgba(var(--red-600-rgb));--red-700-rgb:247,92,70;--red-700:rgba(var(--red-700-rgb));--red-800-rgb:234,56,41;--red-800:rgba(var(--red-800-rgb));--red-900-rgb:211,21,16;--red-900:rgba(var(--red-900-rgb));--red-1000-rgb:180,0,0;--red-1000:rgba(var(--red-1000-rgb));--red-1100-rgb:147,0,0;--red-1100:rgba(var(--red-1100-rgb));--red-1200-rgb:116,0,0;--red-1200:rgba(var(--red-1200-rgb));--red-1300-rgb:89,0,0;--red-1300:rgba(var(--red-1300-rgb));--red-1400-rgb:67,0,0;--red-1400:rgba(var(--red-1400-rgb));--gray-50-rgb:255,255,255;--gray-50:rgb(var(--gray-50-rgb));--gray-75-rgb:253,253,253;--gray-75:rgb(var(--gray-75-rgb));--gray-100-rgb:248,248,248;--gray-100:rgb(var(--gray-100-rgb));--gray-200-rgb:230,230,230;--gray-200:rgb(var(--gray-200-rgb));--gray-300-rgb:213,213,213;--gray-300:rgb(var(--gray-300-rgb));--gray-400-rgb:177,177,177;--gray-400:rgb(var(--gray-400-rgb));--gray-500-rgb:144,144,144;--gray-500:rgb(var(--gray-500-rgb));--gray-600-rgb:109,109,109;--gray-600:rgb(var(--gray-600-rgb));--gray-700-rgb:70,70,70;--gray-700:rgb(var(--gray-700-rgb));--gray-800-rgb:34,34,34;--gray-800:rgb(var(--gray-800-rgb));--gray-900-rgb:0,0,0;--gray-900:rgb(var(--gray-900-rgb))}#sentry-container.dark-mode{--blue-100-rgb:0,56,119;--blue-100:rgba(var(--blue-100-rgb));--blue-200-rgb:0,65,138;--blue-200:rgba(var(--blue-200-rgb));--blue-300-rgb:0,77,163;--blue-300:rgba(var(--blue-300-rgb));--blue-400-rgb:0,89,194;--blue-400:rgba(var(--blue-400-rgb));--blue-500-rgb:3,103,224;--blue-500:rgba(var(--blue-500-rgb));--blue-600-rgb:19,121,243;--blue-600:rgba(var(--blue-600-rgb));--blue-700-rgb:52,143,244;--blue-700:rgba(var(--blue-700-rgb));--blue-800-rgb:84,163,246;--blue-800:rgba(var(--blue-800-rgb));--blue-900-rgb:114,183,249;--blue-900:rgba(var(--blue-900-rgb));--blue-1000-rgb:143,202,252;--blue-1000:rgba(var(--blue-1000-rgb));--blue-1100-rgb:174,219,254;--blue-1100:rgba(var(--blue-1100-rgb));--blue-1200-rgb:204,233,255;--blue-1200:rgba(var(--blue-1200-rgb));--blue-1300-rgb:232,246,255;--blue-1300:rgba(var(--blue-1300-rgb));--blue-1400-rgb:255,255,255;--blue-1400:rgba(var(--blue-1400-rgb));--red-100-rgb:123,0,0;--red-100:rgba(var(--red-100-rgb));--red-200-rgb:141,0,0;--red-200:rgba(var(--red-200-rgb));--red-300-rgb:165,0,0;--red-300:rgba(var(--red-300-rgb));--red-400-rgb:190,4,3;--red-400:rgba(var(--red-400-rgb));--red-500-rgb:215,25,19;--red-500:rgba(var(--red-500-rgb));--red-600-rgb:234,56,41;--red-600:rgba(var(--red-600-rgb));--red-700-rgb:246,88,67;--red-700:rgba(var(--red-700-rgb));--red-800-rgb:255,117,94;--red-800:rgba(var(--red-800-rgb));--red-900-rgb:255,149,129;--red-900:rgba(var(--red-900-rgb));--red-1000-rgb:255,176,161;--red-1000:rgba(var(--red-1000-rgb));--red-1100-rgb:255,201,189;--red-1100:rgba(var(--red-1100-rgb));--red-1200-rgb:255,222,216;--red-1200:rgba(var(--red-1200-rgb));--red-1300-rgb:255,241,238;--red-1300:rgba(var(--red-1300-rgb));--red-1400-rgb:255,255,255;--red-1400:rgba(var(--red-1400-rgb));--gray-50-rgb:29,29,29;--gray-50:rgb(var(--gray-50-rgb));--gray-75-rgb:38,38,38;--gray-75:rgb(var(--gray-75-rgb));--gray-100-rgb:50,50,50;--gray-100:rgb(var(--gray-100-rgb));--gray-200-rgb:63,63,63;--gray-200:rgb(var(--gray-200-rgb));--gray-300-rgb:84,84,84;--gray-300:rgb(var(--gray-300-rgb));--gray-400-rgb:112,112,112;--gray-400:rgb(var(--gray-400-rgb));--gray-500-rgb:144,144,144;--gray-500:rgb(var(--gray-500-rgb));--gray-600-rgb:178,178,178;--gray-600:rgb(var(--gray-600-rgb));--gray-700-rgb:209,209,209;--gray-700:rgb(var(--gray-700-rgb));--gray-800-rgb:235,235,235;--gray-800:rgb(var(--gray-800-rgb));--gray-900-rgb:255,255,255;--gray-900:rgb(var(--gray-900-rgb))}";


/**
 * The locale code that templates in this source code are written in.
 */ const $f1c810362fae7a9b$export$39ee57b29e1d3664 = "en-us";
const $f1c810362fae7a9b$export$70e81b5f5f7c5b5e = [
    "bg-bg",
    "cs-cz",
    "da-dk",
    "de-de",
    "el-gr",
    "en-ae",
    "en-gb",
    "en-hr",
    "en-il",
    "en-ke",
    "en-lk",
    "en-mo",
    "en-mu",
    "en-ng",
    "en-tt",
    "en-us",
    "en-vn",
    "en-xm",
    "es-bo",
    "es-do",
    "es-es",
    "es-la",
    "es-mx",
    "es-na",
    "es-pa",
    "es-py",
    "es-sv",
    "es-uy",
    "et-ee",
    "fi-fi",
    "fil-ph",
    "fr-ca",
    "fr-fr",
    "fr-ma",
    "fr-xm",
    "hi-in",
    "hr-hr",
    "hu-hu",
    "id-id",
    "it-it",
    "in-id",
    "ja-jp",
    "ko-kr",
    "lt-lt",
    "lv-lv",
    "nb-no",
    "nl-nl",
    "ms-my",
    "pl-pl",
    "pt-br",
    "ro-ro",
    "ru-ru",
    "sk-sk",
    "sl-si",
    "sr-rs",
    "sr-sp",
    "sv-se",
    "th-th",
    "tr-tr",
    "uk-ua",
    "vi-vn",
    "zh-cn",
    "zh-hans",
    "zh-hant",
    "zh-mo",
    "zh-tw"
];
const $f1c810362fae7a9b$export$d3a9349734ac9ef2 = [
    "en-us",
    "es-es",
    "fr-fr",
    "sr-rs",
    "zh-cn"
];


const $c537e35bcc5e3259$var$overrides = {
    no: "nb-no",
    "no-no": "nb-no"
};
function $c537e35bcc5e3259$export$3750284cd7e8bdf9(dirtyLocale) {
    const locale = dirtyLocale.toLowerCase().replace("_", "-");
    const [lang] = locale.split("-");
    const override = $c537e35bcc5e3259$var$overrides[locale] || $c537e35bcc5e3259$var$overrides[lang];
    if (override) return override;
    if ((0, $f1c810362fae7a9b$export$70e81b5f5f7c5b5e).includes(locale)) return locale;
    const countryLocale = (0, $f1c810362fae7a9b$export$d3a9349734ac9ef2).find((l)=>l.startsWith(lang)) || (0, $f1c810362fae7a9b$export$70e81b5f5f7c5b5e).find((l)=>l.startsWith(lang));
    if (!countryLocale) return "en-us";
    return countryLocale;
}


const $90228ccbf49da3a8$export$83401e34d5e11bf4 = {
    LOCAL: "local",
    STAGE: "stage",
    PROD: "prod"
};
function $90228ccbf49da3a8$export$57570b1603cf6adb(location, forceStage = false) {
    if (forceStage) return $90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE;
    if (location.includes("localhost")) return $90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL;
    if (location.includes("identity-stage.adobe.com")) return $90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE;
    return $90228ccbf49da3a8$export$83401e34d5e11bf4.PROD;
}
function $90228ccbf49da3a8$export$a7e3aedd9ea505f2(env, mod, locale) {
    if (env === $90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL) return mod.translations;
    return window.ElmTranslations[mod.name][locale];
}
class $90228ccbf49da3a8$export$6c570f6359b75a00 extends Error {
    name = "ElmError";
}
const $90228ccbf49da3a8$export$287a8a35a0a3cbf6 = {
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL]: "https://localhost.corp.adobe.com:8081",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE]: "https://auth-light.identity-stage.adobe.com/sentry",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.PROD]: "https://auth-light.identity.adobe.com/sentry"
};
const $90228ccbf49da3a8$export$3718465abfab658e = {
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL]: "https://localhost.corp.adobe.com:25000",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE]: "https://auth-light.identity-stage.adobe.com",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.PROD]: "https://auth-light.identity.adobe.com"
};
const $90228ccbf49da3a8$export$7c1259bc37236a7a = {
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL]: "https://localhost.corp.adobe.com:4200/signin",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE]: "https://auth-stg1.services.adobe.com/signin/v1/audit",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.PROD]: "https://auth.services.adobe.com/signin/v1/audit"
};
const $90228ccbf49da3a8$export$5818da7754c3da45 = {
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL]: "907a6882-ab0e-470b-b9e2-dacfef7a4b56",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE]: "907a6882-ab0e-470b-b9e2-dacfef7a4b56",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.PROD]: "6f975362-e0ca-4f3a-9e2c-8d45aff664ac"
};
const $90228ccbf49da3a8$export$ae2438354114d579 = {
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL]: "https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-20e1cb549f8d-development.min.js",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE]: "https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-60f5ad31dcdc-staging.min.js",
    [$90228ccbf49da3a8$export$83401e34d5e11bf4.PROD]: "https://assets.adobedtm.com/d4d114c60e50/9893a31a89dc/launch-1b1712458f6e.min.js"
};
const $90228ccbf49da3a8$export$98d7a83c1eacdc67 = (env)=>$90228ccbf49da3a8$export$287a8a35a0a3cbf6[env];
const $90228ccbf49da3a8$export$7b157dbf34b7ba09 = (env)=>$90228ccbf49da3a8$export$3718465abfab658e[env];
const $90228ccbf49da3a8$export$613536d7477983ef = (env)=>$90228ccbf49da3a8$export$7c1259bc37236a7a[env];
const $90228ccbf49da3a8$export$433df29d39384e33 = (env)=>$90228ccbf49da3a8$export$5818da7754c3da45[env];
const $90228ccbf49da3a8$export$fa54871c0f9704d1 = (env)=>$90228ccbf49da3a8$export$ae2438354114d579[env];
const $90228ccbf49da3a8$var$MODULE_PROMISES_STAGE = new Map();
const $90228ccbf49da3a8$var$MODULE_PROMISES_PROD = new Map();
async function $90228ccbf49da3a8$export$442f7492120bc030(mod, forceStage = false) {
    const MODULE_PROMISES = forceStage ? $90228ccbf49da3a8$var$MODULE_PROMISES_STAGE : $90228ccbf49da3a8$var$MODULE_PROMISES_PROD;
    if (!MODULE_PROMISES.has(mod)) {
        const env = $90228ccbf49da3a8$export$57570b1603cf6adb(window.location.href, forceStage);
        const url = $90228ccbf49da3a8$export$98d7a83c1eacdc67(env);
        const promise = $90228ccbf49da3a8$export$99edb48b31c60fa0(`${url}/${mod.script}`);
        MODULE_PROMISES.set(mod, promise);
        return promise;
    } else return MODULE_PROMISES.get(mod);
}
function $90228ccbf49da3a8$export$99edb48b31c60fa0(url) {
    return new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.src = url;
        document.head.appendChild(script);
        script.onload = resolve;
        script.onerror = reject;
    });
}
function $90228ccbf49da3a8$export$a95892402199cb4c(expectedOrigin) {
    return new Promise((resolve, reject)=>{
        function portWaiter(e) {
            if (!expectedOrigin.includes(e.origin)) return;
            if (e.data === "connection") {
                if (e.ports.length === 0) return reject(new Error("Missing port"));
                resolve(e.ports[0]);
                window.removeEventListener("message", portWaiter);
            }
        }
        window.addEventListener("message", portWaiter);
    });
}
function $90228ccbf49da3a8$export$83981d14e606a61f({ url: url, title: title, w: w, h: h }) {
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;
    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
    const left = (width - parseInt(w)) / 2 + dualScreenLeft;
    const top = (height - parseInt(h)) / 2 + dualScreenTop;
    const openedWindow = window.open(url, title, `
    menubar=0,
    resizable=0,
    scrollbars=no,
    width=${w}, 
    height=${h}, 
    top=${top}, 
    left=${left}
    `);
    return openedWindow;
}
function $90228ccbf49da3a8$export$468ff95b83d315e5(value) {
    try {
        return JSON.parse(value);
    } catch (e) {
        return value;
    }
}
function $90228ccbf49da3a8$export$4f069e3727fdda1e(ports, portName, cb) {
    if (ports && Object.prototype.hasOwnProperty.call(ports, portName) && typeof ports[portName] === "object" && typeof ports[portName].subscribe === "function") {
        const port = ports[portName];
        port.subscribe((data)=>cb($90228ccbf49da3a8$export$468ff95b83d315e5(data)));
    } else console.error("No port: " + portName);
}
function $90228ccbf49da3a8$export$2f3ffc2e7c480193() {
    const randomBytes = new Uint8Array(16);
    crypto.getRandomValues(randomBytes);
    randomBytes[6] = randomBytes[6] & 0x0f | 0x40; // Set version to 4 (0100)
    randomBytes[8] = randomBytes[8] & 0x3f | 0x80; // Set variant to 1 (10)
    const toHex = (n)=>n.toString(16).padStart(2, "0");
    const byteToHex = Array.from(randomBytes, toHex);
    const relay = [
        ...byteToHex.slice(0, 4),
        "-",
        ...byteToHex.slice(4, 6),
        "-",
        ...byteToHex.slice(6, 8),
        "-",
        ...byteToHex.slice(8, 10),
        "-",
        ...byteToHex.slice(10)
    ].join("");
    return relay;
}
function $90228ccbf49da3a8$var$setPos(target, { top: top, left: left, right: right, bottom: bottom }) {
    target.style.left = left + "px";
    target.style.top = top + "px";
    target.style.right = right + "px";
    target.style.bottom = bottom + "px";
}
function $90228ccbf49da3a8$export$4cbe607d376c0018(container) {
    const { top: top, left: left, width: width, height: height } = container.getBoundingClientRect();
    $90228ccbf49da3a8$var$setPos(container, {
        top: top,
        left: left,
        right: left + width,
        bottom: top + height
    });
}
function $90228ccbf49da3a8$export$717673b52186c025(container, targetHeight, targetWidth) {
    container.style.position = "fixed";
    container.style.height = targetHeight + "px";
    container.style.width = targetWidth + "px";
    const dh = targetHeight / 2;
    const dw = targetWidth / 2;
    const screenMiddleH = window.innerHeight / 2;
    const screenMiddleW = window.innerWidth / 2;
    $90228ccbf49da3a8$var$setPos(container, {
        top: screenMiddleH - dh,
        left: screenMiddleW - dw,
        right: screenMiddleW + dw,
        bottom: screenMiddleH + dh
    });
}
function $90228ccbf49da3a8$export$ffb8c99408031bcb(env) {
    switch(env){
        case $90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL:
            return "susi-light-local";
        case $90228ccbf49da3a8$export$83401e34d5e11bf4.STAGE:
            return "susi-light-stage";
        case $90228ccbf49da3a8$export$83401e34d5e11bf4.PROD:
            return "susi-light-prod";
        default:
            return "susi-light-unknown";
    }
}
function $90228ccbf49da3a8$export$e033206476818195(env, clientId, relay, variant) {
    const envName = $90228ccbf49da3a8$export$ffb8c99408031bcb(env);
    return function(log) {
        if (env === $90228ccbf49da3a8$export$83401e34d5e11bf4.LOCAL) return Promise.resolve();
        fetch($90228ccbf49da3a8$export$613536d7477983ef(env), {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-IMS-CLIENTID": clientId,
                "X-DEBUG-ID": relay
            },
            body: JSON.stringify({
                ...log,
                variant: variant,
                envName: envName,
                clientId: clientId
            })
        });
    };
}


const $9303e6e9541ca680$var$versions = {
    "variants": [
        [
            "edu-express",
            "EduExpress"
        ],
        [
            "sandbox",
            "Sandbox"
        ],
        [
            "standard",
            "Standard"
        ]
    ],
    "locales": [
        "bg-bg",
        "cs-cz",
        "da-dk",
        "de-de",
        "el-gr",
        "en-ae",
        "en-gb",
        "en-hr",
        "en-il",
        "en-ke",
        "en-lk",
        "en-mo",
        "en-mu",
        "en-ng",
        "en-tt",
        "en-us",
        "en-vn",
        "en-xm",
        "es-bo",
        "es-do",
        "es-es",
        "es-la",
        "es-mx",
        "es-na",
        "es-pa",
        "es-py",
        "es-sv",
        "es-uy",
        "et-ee",
        "fi-fi",
        "fil-ph",
        "fr-ca",
        "fr-fr",
        "fr-ma",
        "fr-xm",
        "hi-in",
        "hr-hr",
        "hu-hu",
        "id-id",
        "in-id",
        "it-it",
        "ja-jp",
        "ko-kr",
        "lt-lt",
        "lv-lv",
        "ms-my",
        "nb-no",
        "nl-nl",
        "pl-pl",
        "pt-br",
        "ro-ro",
        "ru-ru",
        "sk-sk",
        "sl-si",
        "sr-rs",
        "sr-sp",
        "sv-se",
        "th-th",
        "tr-tr",
        "uk-ua",
        "vi-vn",
        "zh-cn",
        "zh-hans",
        "zh-hant",
        "zh-mo",
        "zh-tw"
    ],
    "hash": "06a71b32",
    "example": "__NAME__.__LOCALE__.06a71b32.js"
};
var $9303e6e9541ca680$export$2e2bcd8739ae039 = $9303e6e9541ca680$var$versions;


const $e20f68555bef609a$var$variants = new Map((0, $9303e6e9541ca680$export$2e2bcd8739ae039).variants);
const $e20f68555bef609a$var$modules = new Map();
function $e20f68555bef609a$var$getModule(variantName, requestedLocale) {
    const mod = $e20f68555bef609a$var$variants.get(variantName);
    let locale = (0, $c537e35bcc5e3259$export$3750284cd7e8bdf9)(requestedLocale);
    if (!mod) throw new Error("Invalid variant.");
    if (!(0, $9303e6e9541ca680$export$2e2bcd8739ae039).locales.includes(locale)) {
        console.warn(`Locale ${locale} not found for variant ${variantName}, defaulting to "en-us".`);
        locale = "en-us";
    }
    const script = (0, $9303e6e9541ca680$export$2e2bcd8739ae039).example.replace("__NAME__", variantName).replace("__LOCALE__", locale);
    if (!$e20f68555bef609a$var$modules.has(script)) $e20f68555bef609a$var$modules.set(script, {
        script: script,
        name: mod,
        translations: (0, $9303e6e9541ca680$export$2e2bcd8739ae039).translations
    });
    return $e20f68555bef609a$var$modules.get(script);
}
const $e20f68555bef609a$var$mandatoryParams = [
    "relay",
    "client_id",
    "locale",
    "redirect_uri",
    "scope",
    "sl",
    "response_type",
    "dt"
];
document.querySelectorAll('meta[name="susi-sentry-preload"]').forEach((meta)=>{
    const forceStage = meta.dataset.stage === "true";
    const locale = meta.dataset.locale;
    const mod = $e20f68555bef609a$var$getModule(meta.content, locale);
    mod && (0, $90228ccbf49da3a8$export$442f7492120bc030)(mod, forceStage);
});
class $e20f68555bef609a$var$SentryWrapper extends HTMLElement {
    // ROOT
    renderRoot;
    isConstructed = false;
    // Temp state to detect changes
    _authparams = null;
    _config = null;
    _variant = null;
    _stage = false;
    _popup = false;
    module;
    _variantPromise = null;
    logMessage;
    _messageHandler = null;
    _port = null;
    _portMessageHandler = null;
    requiredParams = [
        "authParams",
        "config",
        "variant"
    ];
    constructor(){
        super();
        try {
            this.renderRoot = this.attachShadow({
                mode: "open"
            });
            this.popup = this.getAttribute("popup") === "true";
            this.stage = this.getAttribute("stage") === "true";
            this.variant = this.getAttribute("variant");
        } catch (e) {
            console.warn("SUSI Light - Missing parameters on init.", e);
        } // Treat initial values as optional
    }
    connectedCallback() {
        this.isConstructed = true;
        this.attemptRenderModule();
    }
    disconnectedCallback() {
        if (this._messageHandler) {
            window.removeEventListener("message", this._messageHandler);
            this._messageHandler = null;
        }
        if (this._port) {
            this._port.close();
            this._port = null;
            this._portMessageHandler = null;
        }
    }
    set variant(value) {
        if (value) this._variant = value;
        this.attemptRenderModule();
    }
    get variant() {
        return this._variant ?? "";
    }
    get locale() {
        return this.authParams.locale;
    }
    get popup() {
        return this._popup;
    }
    set popup(val) {
        this._popup = typeof val === "string" ? val === "true" : Boolean(val);
        this.attemptRenderModule();
    }
    get stage() {
        return this._stage;
    }
    set stage(val) {
        this._stage = typeof val === "string" ? val === "true" : Boolean(val);
        this.attemptRenderModule();
    }
    get darkMode() {
        return this.authParams?.dt;
    }
    set authParams(value) {
        this._authparams = value;
        this.attemptRenderModule();
    }
    get authParams() {
        return this._authparams;
    }
    set config(value) {
        this._config = value;
        this.attemptRenderModule();
    }
    get config() {
        return this._config;
    }
    get systemParams() {
        return {
            mode: Boolean(this.popup) ? "popup" : "redirect"
        };
    }
    get appState() {
        if (!this.authParams) return {};
        const relay = this.authParams.relay ?? (0, $90228ccbf49da3a8$export$2f3ffc2e7c480193)();
        const sl_stage = !!this.stage;
        const params = {
            ...this.authParams,
            sl: window.origin,
            sl_stage: sl_stage,
            relay: relay
        };
        const isMandatory = (key)=>$e20f68555bef609a$var$mandatoryParams.includes(key);
        const queryState = Object.fromEntries(Object.entries(params).filter(([key, val])=>val && isMandatory(key)));
        const authParams = Object.entries(params).map(([k, v])=>[
                k,
                v.toString()
            ]);
        return {
            queryState: queryState,
            authParams: authParams,
            systemParams: this.systemParams,
            config: this.config
        };
    }
    async initializeApplication(root, port) {
        const env = (0, $90228ccbf49da3a8$export$57570b1603cf6adb)(window.location.href, this.stage);
        const translations = (0, $90228ccbf49da3a8$export$a7e3aedd9ea505f2)(env, this.module, (0, $c537e35bcc5e3259$export$3750284cd7e8bdf9)(this.locale));
        const app = window.Elm[this.module.name].Main.init({
            node: root,
            flags: {
                ...this.appState,
                translations: translations
            }
        });
        if (app.ports) {
            (0, $90228ccbf49da3a8$export$4f069e3727fdda1e)(app.ports, "onOpenPopup", (url)=>{
                (0, $90228ccbf49da3a8$export$83981d14e606a61f)({
                    url: url,
                    title: "SUSI Light Login",
                    w: "688",
                    h: "768"
                });
            });
            (0, $90228ccbf49da3a8$export$4f069e3727fdda1e)(app.ports, "onSentryEvent", (event)=>{
                this.dispatchEvent(new CustomEvent(event.name, {
                    detail: event.data
                }));
                if (event.name === "on-analytics") {
                    port.postMessage(event);
                    this.logMessage({
                        name: "app-analytics",
                        message: event.data
                    });
                }
            });
            (0, $90228ccbf49da3a8$export$4f069e3727fdda1e)(app.ports, "onLogMessage", (event)=>{
                if (event.name === "app-error") {
                    const error = new (0, $90228ccbf49da3a8$export$6c570f6359b75a00)(event.message);
                    this.dispatchError(error);
                } else this.logMessage(event);
            });
        }
        return app;
    }
    static observedAttributes = [
        "authParams",
        "config",
        "stage",
        "variant",
        "stage",
        "popup"
    ];
    createShadow() {
        return this.attachShadow({
            mode: "closed"
        });
    }
    renderModule() {
        this.module = $e20f68555bef609a$var$getModule(this.variant, this.locale);
        this._variantPromise = (0, $90228ccbf49da3a8$export$442f7492120bc030)(this.module, this.stage);
        if (this.isConstructed) this.render();
    }
    attemptRenderModule() {
        const missingParams = this.requiredParams.filter((key)=>!this[key]);
        if (missingParams.length > 0) {
            console.warn(`All required parameters not yet supplied: ${missingParams.join(", ")}`);
            return;
        }
        const { queryState: queryState } = this.appState;
        const env = (0, $90228ccbf49da3a8$export$57570b1603cf6adb)(window.location.href, this.stage);
        this.logMessage = (0, $90228ccbf49da3a8$export$e033206476818195)(env, queryState.client_id, queryState.relay, this.variant);
        this.renderModule();
    }
    async render() {
        const env = (0, $90228ccbf49da3a8$export$57570b1603cf6adb)(window.location.href, this.stage);
        const iframeUrl = (0, $90228ccbf49da3a8$export$7b157dbf34b7ba09)(env);
        const portPromise = (0, $90228ccbf49da3a8$export$a95892402199cb4c)(iframeUrl);
        const { client_id: client_id, relay: relay } = this.appState.queryState;
        const isValidOrigin = this.authParams.st_valid_origin;
        function makeIframeUrl() {
            const url = new URL("/sentry/iframe/index.html", iframeUrl);
            url.searchParams.append("client_id", client_id);
            url.searchParams.append("relay", relay);
            if (isValidOrigin) url.searchParams.append("st_valid_origin", "true");
            url.searchParams.append("asserted_origin", window.location.origin);
            return url.toString();
        }
        const colorTheme = this.darkMode ? "dark-mode" : "light-mode";
        if (this.shadowRoot) this.shadowRoot.innerHTML = `
        <style>
          ${0, (/*@__PURE__*/$parcel$interopDefault($f894f8ec569435b3$exports))}
        </style>
        <section id="sentry-container" class=${colorTheme}>
          <section id="sentry"></section>
        </section>
        <iframe
          aria-hidden="true"
          id="sentry-iframe"
          height="1px" 
          width="1px" 
          src="${makeIframeUrl()}" />
    `;
        else throw new Error("shadowRoot not available");
        try {
            const [port] = await Promise.all([
                portPromise,
                this._variantPromise
            ]);
            const app = await this.initializeApplication(this.renderRoot.getElementById("sentry"), port);
            const logError = this.logMessage;
            this._messageHandler = (e)=>{
                if ([
                    "localhost.corp.adobe.com",
                    "auth-light.identity-stage.adobe.com",
                    "auth-light.identity.adobe.com"
                ].some((origin)=>e.origin.includes(origin))) try {
                    const event = (0, $90228ccbf49da3a8$export$468ff95b83d315e5)(e.data);
                    const subEvent = (0, $90228ccbf49da3a8$export$468ff95b83d315e5)(event.data);
                    if (app.ports && event.name === "query-state") app.ports.onPopupMessage.send(subEvent);
                    if (event.name === "open-popup-error") {
                        logError({
                            name: "app-info",
                            message: event
                        });
                        // Pass the subEvent to Elm application through the dedicated popup error port
                        if (app.ports && app.ports.onPopupError) app.ports.onPopupError.send(subEvent);
                    }
                } catch (e) {
                    logError({
                        name: "app-critical",
                        message: {
                            error: {
                                message: e.toString()
                            }
                        }
                    });
                }
            };
            this._portMessageHandler = (e)=>{
                try {
                    const event = (0, $90228ccbf49da3a8$export$468ff95b83d315e5)(e.data);
                    const subEvent = (0, $90228ccbf49da3a8$export$468ff95b83d315e5)(event.data);
                    if (app.ports && event.name === "query-state") app.ports.onPopupMessage.send(subEvent);
                    else if (event.name === "origin-validation-status") logError({
                        name: "app-info",
                        message: subEvent
                    });
                    else console.log(e);
                } catch (e) {
                    logError({
                        name: "app-critical",
                        message: {
                            error: {
                                message: e.toString()
                            }
                        }
                    });
                }
            };
            this._port = port;
            window.addEventListener("message", this._messageHandler);
            port.onmessage = this._portMessageHandler;
        } catch (e) {
            this.dispatchError(e);
        }
    }
    dispatchError(error) {
        const errorEvent = {
            name: "unrecoverable",
            error: {
                name: error.name,
                message: error.message,
                stack: error.stack
            }
        };
        this.logMessage({
            name: "app-error",
            message: errorEvent
        });
        this.dispatchEvent(new CustomEvent("on-error", {
            detail: errorEvent
        }));
    }
}
// TODO: Handle tag name differential
window.customElements.define("susi-sentry-light", $e20f68555bef609a$var$SentryWrapper);

})();
//# sourceMappingURL=wrapper.js.map
